import { useQuery } from '@hooks/reactQuery';

import { getMavenirConfigTypes } from '@api/dataSources';

import { optionsFormattedWithArray } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { MAVENIR_CONFIG_TYPES } from '@constants/queryKeys';

interface IMavenirConfigTypeOptionsReturnType {
	typeOptions: TSelectOption<string>[];
	isLoadingTypesOptions: boolean;
}

const useQueryMavenirConfigTypeOptions = (): IMavenirConfigTypeOptionsReturnType => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<string[], TSelectOption<string>[]>({
		queryKey: [MAVENIR_CONFIG_TYPES],
		queryFn: getMavenirConfigTypes,
		select: (items) => {
			const sortedItems = items.sort((a, b) => a.localeCompare(b));

			return optionsFormattedWithArray(sortedItems);
		},
		...refetchOptions,
	});

	return {
		typeOptions: data || [],
		isLoadingTypesOptions: isLoading || isFetching,
	};
};

export default useQueryMavenirConfigTypeOptions;
